export function getBody () {
  var doc = document,
      body = doc.body;

  if (!body) {
    body = doc.createElement('body');
    body.fake = true;
  }

  return body;
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/getBody.js
// module id = 161
// module chunks = 2